<template>
  <section class="businesses">
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
          <div
      v-if="loading"
      class="d-flex p-2 spinner-border loading-spinner mx-auto"
      role="status"
    >
      <span class="sr-only">{{ $t("lang.search.loading") }}...</span>
    </div>
      <div v-if="!loading">
        <Promotion
          v-if="
            user.plan_id == 3 &&
            user.is_agency == 1 &&
            user.order_created == 1 &&
            totalContacts == 0 &&
            !cancelPromotion &&
            user.role_id != 3
          "
          @cancel="cancel($emit)"
        />
        <div v-else>
          <PreparingApp
            :user="user"
            v-if="user.order_created == 1 || user.role_id == 3"
          />

          <div class="ml-2 mr-2" v-else>
            <div
              class="card my-3 py-1 bg-primary text-light text-bold"
              v-if="
                onBoarding.step == 1 &&
                onBoarding.orderId != undefined &&
                onBoarding.orderId > 0
              "
            >
              <div class="row">
                <div class="col-10">
                  <span class="icon-save btn"></span>
                  <span class="font-weight-bold">{{
                    $t("lang.onBoarding.resume_your_order")
                  }}</span>
                </div>
                <div class="col-2 text-right">
                  <button
                    class="
                      btn
                      large
                      cursor-pointer
                      font-weight-bolder
                      btn-sm btn-light
                      mx-1
                      px-4
                    "
                    @click="sendToStep(3, 1)"
                  >
                    {{ $t("lang.onBoarding.continue_editing") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="row">

              <div class="col-md-2" v-if="onBoarding.step == 1">
              </div>
              <div class="col-md-8">
                <MultiStep
                  v-if="!loading"
                  :targetId="targetId"
                  :typeForm="'onboarding'"
                />
              </div>
              <div class="col-md-2" v-if="onBoarding.step == 1">
              </div>
              <div class="col-md-4" v-if="onBoarding.step != 1">
                <Summary />

                <div class="card mt-3" v-if="onBoarding.step == 1">
                  <div class="card-body">
                    <div class="p-2 d-flex">
                      <span class="icon-wrench btn"></span>
                      <span>{{
                        $t("lang.onBoarding.no_fee_for_campaign")
                      }}</span>
                    </div>

                    <div class="p-2 d-flex">
                      <span class="icon-hand-o-up btn"></span>
                      <span>{{ $t("lang.onBoarding.no_commitment") }}</span>
                    </div>
                    <div class="p-2 d-flex">
                      <span class="icon-clock-o btn"></span>
                      <span>{{
                        $t("lang.onBoarding.pay_only_per_appointment")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

  </section>
</template>

<script>
import MultiStep from "@/components/Onboarding/MultiStep.vue";
import Summary from "@/components/Onboarding/Summary.vue";
import { mapState, mapActions } from "vuex";
import {
  targetsService,
  usersService,
  businessContactsService,
} from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import PreparingApp from "@/components/PreparingApp.vue";
import Promotion from "@/views/Promotion.vue";

export default {
  data() {
    return {
      totalContacts: 0,
      cancelPromotion: false,
      targetId: false,
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" },
      ],
      size: [],
      loading: false,
      model: {
        currentPage: 1,
        status: { buy: true },
      },
    };
  },
  mounted() {},
  created() {
    this.loading = true;
    console.log("enter to onboarding...");
    businessContactsService.total(this.model).then((response) => {
      if (response !== undefined) {
        this.totalContacts = parseInt(response.total);
        this.loading = false;
      }
    });

    this.targetId = false;
    if (
      this.user.plan_id == 3 &&
      this.user.is_agency == 1 &&
      this.user.order_created == 1
    ) {
      // this.$router.push("/promotion");
    } else {
      if (parseInt(this.user.agency_signed) !== 0) {
        targetsService.getAll().then((response) => {
          if (response.length > 0) {
            this.targetId = response[response.length - 1].id;
          }
          if (this.targetId) {
            this.loadTarget(this.targetId);
          } else {
            this.$forceUpdate();
            this.clean();
            this.goToStep(1);
            this.goToSubStep(0);
          }

          if (this.targetId) {
            if (this.$route.params.step == undefined) {
              this.goToStep(3);
              this.goToSubStep(1);
            } else {
              this.goTo(this.$route.params);
            }
          }
        });
      } else {
        this.$router.push("/onboarding");
      }
    }
  },
  components: {
    MultiStep,
    Summary,
    LoadingSpinner,
    PreparingApp,
    Promotion,
  },
  computed: {
    ...mapState({
      onBoarding: (state) => state.onboarding,
      loading: (state) => state.onboarding.loading,
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      user: (state) => state.authentication.user,
    }),
  },
  methods: {
    ...mapActions("onboarding", {
      goToStep: "goToStep",
      goTo: "goTo",
      goToSubStep: "goToSubStep",
      loadTarget: "loadTarget",
      clean: "clean",
    }),

    sendToStep(step, substep) {
      this.goToStep(step);
      this.goToSubStep(substep);
    },
    cancel($emit) {
      this.cancelPromotion = $emit;
    },
  },
};
</script>
